import { render, staticRenderFns } from "./NewProposalConfirmationModal.vue?vue&type=template&id=51ce6f3e&scoped=true"
import script from "./newProposalConfirmationModal.ts?vue&type=script&lang=ts&external"
export * from "./newProposalConfirmationModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ce6f3e",
  null
  
)

export default component.exports